import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';

type MarkProps = {
  children: React.ReactNode;
  strong?: boolean;
  className?: string;
  onClickCapture?: React.MouseEventHandler<HTMLParagraphElement>;
};

const Mark: React.FC<MarkProps> = ({
  children,
  strong,
  className,
  onClickCapture,
}) => {
  const classNamePrefix = 'mark';
  const _className = classNames(className, styles[classNamePrefix], {
    [styles[`${classNamePrefix}-strong`]]: strong,
  });

  return (
    <p className={_className} onClickCapture={onClickCapture}>
      {children}
    </p>
  );
};

export { Mark };
